import { render, staticRenderFns } from "./acco_policy.vue?vue&type=template&id=6e1bdfac&"
import script from "./acco_policy.vue?vue&type=script&lang=js&"
export * from "./acco_policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports